<mojo-lister entityName="HeadLease"
             [ownerEntityKey]="entityKey$ | async"
             (onRowSelect)="handleRowSelect($event)"
             [getRowHref]="getRowHref">
</mojo-lister>
